import React, { useContext } from 'react';
import { useMutation } from '@apollo/client';
import { KodplanContext } from '../../../../../../../../../../../../Components/KodplanManager/Context/KodplanContext';
import { rutinInfos } from '../../../../../../../../../../_Common/Const/RutinInfo';
import EkonomiskAnalysInitQuery from '../../../../../../../Queries/EkonomiskAnalysInitQuery/AnalysInitQuery.gql';
import changeStartAnalysMutation from './ChangeStartAnalysMutation.gql';
import { ActiveDatabaseContext } from '../../../../../../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { EkonomiskAnalysSelectContext } from '../../../../../Components/AnalysSelect/Context/EkonomiskAnalysSelectContext';
import {
  ISelectedAnalysAnalys,
  ISelectedAnalysCodePrivilege,
} from '../../../../../../../EkonomiskAnalysPage';
import { ISelection } from '../../../../../../../Queries/EkonomiskAnalysInitQuery/EkonomiskAnalysInitQuery';
import { getSelectedAnalys } from '../../../../../../../Utils/userInfoUtils';
import {
  ChangeStartAnalysMutation as IChangeStartAnalysMutationData,
  ChangeStartAnalysMutationVariables as IChangeStartAnalysMutationVariables,
} from './_QueryTypes/ChangeStartAnalysMutation';
import Logger from '../../../../../../../../../../../../Utils/Logger';
import { USE_NEW_AS_START_ANALYS_ID } from '../../EkonomiskAnalysFavoriteAnalysDialog';
import { padRoutineId } from '../../../../../../../../../../../../Utils/dbSettingsUtils';

interface IProps {
  children: (mutateFn: SaveStartAnalysFnType) => React.ReactNode;
  fullAnalysList: ISelection[];
}

export interface IStartAnalysInfo {
  rapportId: string | undefined;
  idKod: string | undefined;
  utdelningLopnr: number | null | undefined;
  kodbehorighet: string;
  kodplanId: string | undefined;
}

export type SaveStartAnalysFnType = (
  startAnalysInfo?: IStartAnalysInfo,
  callback?: (
    analys: ISelectedAnalysAnalys | null,
    codePrivilege: ISelectedAnalysCodePrivilege | null,
    unsavedAnalys?: boolean,
    callback?: () => void,
    newAnalys?: boolean
  ) => void
) => void;

export const paddedEkonomiskAnalysRutinId = padRoutineId(
  rutinInfos.rtnEkonomiskAnalys.rutinID
);

const ChangeStartAnalysMutation: React.FunctionComponent<IProps> = props => {
  const kodplanContext = useContext(KodplanContext);
  const activeDatabaseContext = useContext(ActiveDatabaseContext);
  const { deselectAnalys } = useContext(EkonomiskAnalysSelectContext);

  const [changeStartAnalysMutationFn] = useMutation<
    IChangeStartAnalysMutationData,
    IChangeStartAnalysMutationVariables
  >(changeStartAnalysMutation);

  const changeStartAnalys: SaveStartAnalysFnType = (
    changedAnalys,
    callback
  ) => {
    if (activeDatabaseContext.activeDatabase && kodplanContext.activeKodplan) {
      let valueField: string | null = null;
      const codeplanID = kodplanContext.activeKodplan.id;
      if (changedAnalys) {
        valueField = JSON.stringify({
          ...changedAnalys,
          kodplanId: codeplanID,
        });
      }

      changeStartAnalysMutationFn({
        variables: {
          dbname: activeDatabaseContext.activeDatabase,
          startAnalysInfo: valueField,
        },
        refetchQueries: result => {
          if (result && result.data && result.errors == null) {
            return [
              {
                query: EkonomiskAnalysInitQuery,
                variables: {
                  codeSystemId: codeplanID,
                  dbName: activeDatabaseContext.activeDatabase ?? '',
                  onlyFavorites: false,
                  section: [`Forms/${paddedEkonomiskAnalysRutinId}`],
                  subsystemCode: 'EK',
                },
              },
            ];
          } else {
            return [];
          }
        },
      }).then(res => {
        if (
          res &&
          res.data &&
          res.errors == null &&
          changedAnalys &&
          callback
        ) {
          if (changedAnalys.rapportId !== USE_NEW_AS_START_ANALYS_ID) {
            const analys = getSelectedAnalys(
              props.fullAnalysList,
              changedAnalys
            );

            if (analys) {
              callback(analys.analys, {
                id: changedAnalys.kodbehorighet,
                name: analys.codePrivilege.name,
              });
            }
          } else {
            callback(null, null, undefined, undefined, true);
          }
        } else if (
          res &&
          res.data?.ekanalys_save_startanalys === 'borttagen' &&
          res.errors == null
        ) {
          deselectAnalys();
        }
      });
    } else {
      Logger.error(
        Error(
          `Kunde ej ändra startanalys, activeDatabase: ${activeDatabaseContext.activeDatabase}, activeKodplan: ${kodplanContext.activeKodplan}`
        )
      );
    }
  };

  return <>{props.children(changeStartAnalys)}</>;
};

export default ChangeStartAnalysMutation;
